import type { Challan } from '../types';

export const challanFixtures: Record<
  'empty' | 'short' | 'long' | 'mixed',
  Challan[]
> = {
  empty: [],
  short: [
    {
      id: 'ch-001',
      authority: 'Mumbai Traffic Police',
      violation: 'No Parking Zone',
      date: '2025-12-18',
      amount: 500,
      status: 'pending',
    },
  ],
  long: [
    {
      id: 'ch-101',
      authority: 'Mumbai Traffic Police',
      violation: 'No Parking Zone',
      date: '2025-12-18',
      amount: 500,
      status: 'pending',
    },
    {
      id: 'ch-102',
      authority: 'Delhi Traffic Police',
      violation: 'Over Speeding',
      date: '2025-11-22',
      amount: 1500,
      status: 'pending',
    },
    {
      id: 'ch-103',
      authority: 'Haryana Highway Patrol',
      violation: 'Seat Belt Violation',
      date: '2025-10-05',
      amount: 1000,
      status: 'pending',
    },
    {
      id: 'ch-104',
      authority: 'Mumbai Traffic Police',
      violation: 'Wrong Side Driving',
      date: '2025-09-12',
      amount: 700,
      status: 'pending',
    },
    {
      id: 'ch-105',
      authority: 'Delhi Traffic Police',
      violation: 'Red Light Jump',
      date: '2025-08-30',
      amount: 1000,
      status: 'pending',
    },
    {
      id: 'ch-106',
      authority: 'Highway Patrol',
      violation: 'Dangerous Driving',
      date: '2025-07-14',
      amount: 3500,
      status: 'pending',
    },
  ],
  mixed: [
    {
      id: 'ch-201',
      authority: 'Mumbai Traffic Police',
      violation: 'No Parking Zone',
      date: '2025-12-18',
      amount: 500,
      status: 'pending',
    },
    {
      id: 'ch-202',
      authority: 'Delhi Traffic Police',
      violation: 'Over Speeding',
      date: '2025-11-22',
      amount: 1500,
      status: 'pending',
    },
    {
      id: 'ch-203',
      authority: 'Haryana Highway Patrol',
      violation: 'Seat Belt Violation',
      date: '2025-10-05',
      amount: 400,
      status: 'paid',
    },
    {
      id: 'ch-204',
      authority: 'Mumbai Traffic Police',
      violation: 'Wrong Side Driving',
      date: '2025-09-12',
      amount: 700,
      status: 'paid',
    },
  ],
};
